<template>
  <router-link class="items-container__item item" :class="{ 'add-new-item': item.isNewRoute }" :to="item.isNewRoute ? { name: 'add-map' } : { name: 'map', params: {id: item.id}}">
    <div class="item__row item__title">
      {{ item.name }}
    </div>
  </router-link>
</template>

<script>
export default {
  props: ['item'],
};
</script>



// WEBPACK FOOTER //
// src/components/maps/ListItemTemplate.vue